module.exports = __webpack_public_path__ + "img/sj-five.5bcd4e94.png";